import { gql } from '@apollo/client';

export const SUB_MGMT_SUBSCRIPTION_FIELDS = gql`
  fragment subMgmtFields on SubscriptionEntityV2 {
    uuid
    startWeek
    endWeek
    legacyOrderId
    displayName
    status
    carts {
      status
      customizeBy
    }
    orders(count: 1, statuses: [PROCESSED, FAILED_PROCESSING]) {
      fulfilled
      cart {
        status
        customizeBy
      }
    }
    cancellation {
      createdAt
    }
    subscriptionDeliveries {
      day
      quantity
    }
    metro {
      legacyRailsId
    }
    paymentMethod {
      ... on ApplePayV2 {
        displayName
        network
        expirationMonth
        expirationYear
        lastFour
      }
      ... on CreditCardV2 {
        displayName
        network
        expirationMonth
        expirationYear
        lastFour
      }
      ... on PayPalV2 {
        displayName
        email
      }
    }
  }
`;
